<template>
  <div
    class="homeStart"
    v-loading="loading"
    :element-loading-text="tran_loading"
    element-loading-spinner="el-icon-loading"
    element-loading-background="rgba(0, 0, 0, 0.8)"
  >
    <img class="bg" src="static/home_center.png" />
    <div class="text1">{{ i18n.center_black }}</div>
    <div class="text2">{{ i18n.center_yellow }}</div>
    <button class="playAndPlay" v-show="isIos" @click="openNfc">
      {{ i18n.button }}
    </button>
    <i class="el-icon-s-unfold left-menu" @click="drawer = true"></i>
    <el-drawer
      :visible.sync="drawer"
      :with-header="true"
      :direction="direction"
      style="width: 200%"
      :withHeader="withHeader"
    >
      <el-row>
        <el-col>
          <h5></h5>
          <el-menu @open="handleOpen" @close="handleClose">
            <el-menu-item index="1" @click="gotoAbout">
              <img class="my_menu" src="static/menu_about.png" />
              <span slot="title" style="font-family: PingFang">{{
                i18n.about_us
              }}</span>
            </el-menu-item>
            <el-menu-item index="2" @click="gotoProduct">
              <img class="my_menu" src="static/menu_product.png" />
              <span slot="title" style="font-family: PingFang">{{
                i18n.product_introduced
              }}</span>
            </el-menu-item>
            <el-menu-item v-show="clientType == '1'" index="3" @click="switchVersion">
              <img class="my_menu" src="static/menu_update.png" />
              <span slot="title" style="font-family: PingFang">{{
                i18n.version_switch
              }}</span>
            </el-menu-item>
            <el-menu-item
              v-show="!isIos && clientType != '1'"
              index="4"
              @click="gotoUpdate"
            >
              <img class="my_menu" src="static/menu_update.png" />
              <span slot="title" style="font-family: PingFang">{{
                i18n.update
              }}</span>
            </el-menu-item>
            <!-- <el-menu-item index="4" @click="gotoFeedback">
              <img class="my_menu" src="static/menu_feedback.png" />
              <span slot="title" style="font-family:PingFang">{{
                i18n.feedback
              }}</span>
            </el-menu-item> -->
          </el-menu>
        </el-col>
      </el-row>
    </el-drawer>
    <div class="mask_one">
      <div class="mask" v-show="showError" @click="closeError"></div>
      <div class="error_center" v-show="showError">
        <img
          class="error_img"
          :src="
            srcFlag ? '/static/error_center.png' : '/static/error_center_en.png'
          "
        />
        <div class="error_text">
          <div class="error_text_center_content">{{ error_message }}</div>
        </div>
      </div>
    </div>
    <div class="mask_two">
      <div class="mask" v-show="showHint" @click="closeHint"></div>
      <div class="hint_center" v-show="showHint">
        <img class="hint_img" src="/static/hint_center.png" />
        <div class="hint_text">
          <div class="hint_text_center_title">{{ i18n.reminder }}</div>
          <div class="hint_text_center_content">{{ hint_message }}</div>
        </div>
      </div>
    </div>
    <!-- <button
      style="
              width: 100px;
              height: 50px;
              background: red;
              z-index: 2;
              position: absolute;
              top: 0;
              right: 50%;
          "
      @click="hello"/> -->
  </div>
</template>

<script>
import axios from "axios";
import CryptoJS from 'crypto-js/crypto-js'
import urlParam from "../../../common/url.js";
// import "../../assets/mock.js";
export default {
  name: "home",
  data() {
    return {
      srcFlag: true,
      info: null,
      loading: false,
      drawer: false,
      direction: "ltr",
      withHeader: false,
      showError: false,
      showHint: false,
      hint_message: "",
      error_message: "",
      tran_loading: "",
      responseData: null, // 微信小程序过来的url
      clientType: "",
      statusCode: "",
      isIos: false
    };
  },
  computed: {
    i18n() {
      this.hint_message = this.$t("home.hint_message");
      this.error_message = this.$t("home.error_message");
      this.tran_loading = this.$t("home.keep_phone");
      return this.$t("home");
    },
  },
  beforeCreate() {
    document.title = this.$route.meta.title
  },
  mounted() {
    // java调用js需要把方法挂在到window上面
    window.initNfc = this.initNfc;
    window.doSingle = this.doSingle;
    window.checkCardStatus = this.checkCardStatus;
    window.getResultCode = this.getResultCode;
    // 只有在主页才可以进行交互，告诉可以发送消息
    // window.jsBridge.callInteraction();
    //中英文
    if (navigator.language.indexOf("zh") != -1) {
      this.srcFlag = true;
    } else {
      this.srcFlag = false;
    }
    // 判断机型
    let ua = navigator.userAgent.toLowerCase(); //Ios终端
    
    this.isIos = !!ua.match(/\(i[^;]+;( u;)? cpu.+mac os x/);
    this.weixinT();
  },
  destroyed() {
    // 从window上把监听方法置空
    window.initNfc = null;
    window.doSingle = null;
    window.checkCardStatus = null;
    window.getResultCode = null;
    // 只有在主页才可以进行交互，通知app
    // window.jsBridge.callNoInteraction();
  },
  methods: {
    // hello() {
    //   //initNfc("2b43c5304e511de0");
    //   //doSingle("1111111111111111","1234","2b43c5304e511de0");
    //   checkCardStatus({"check":105,"checkFlag":"1","open":"","notOpen":"","hide":"",});
    // },
    weixinT() {
      // 微信小程序设计
      let ct = window.localStorage.getItem("clientType");
      if (ct && ct === "1") {
        this.clientType = "1";
        this.isIos = false;
      }
      if (urlParam.getUrlKey("clientType")) {
        this.clientType = urlParam.getUrlKey("clientType");
        this.isIos = false;
        window.localStorage.setItem("clientType", this.clientType);
      }
      if (urlParam.getUrlKey("statusCode")) {
        this.statusCode = urlParam.getUrlKey("statusCode");
      }
      if (this.clientType === "1") {
        if (this.statusCode === "1004") {
          this.showError = true;
          this.error_message = this.$t("home.error_official");
        } 
        else if (this.statusCode === "1005") {
          this.showError = true;
          this.error_message = this.$t("home.error_authentication");
        }
        else if (this.statusCode === "1006" || this.statusCode === "1003") {
        }
        else if (this.statusCode === "0" || this.statusCode == null || this.statusCode == "")
        {
        }
        else {
          this.showHint = true;
          this.hint_message = this.$t("home.hint_service");
        }
      }
    },
    closeError() {
      this.showError = false;
    },
    closeHint() {
      this.showHint = false;
    },
    // 苹果开启nfc
    openNfc() {
      window.webkit.messageHandlers.openNfc.postMessage(null);
    },
    initNfc(msg) {
      this.loading = true;
      let requestUrl = "/zpws/api/hs02/init";
      // 标签认证初始化
      let clientName = "client_jgwcjm";
      let timestamp = (Math.round(new Date().getTime()/1000)).toString();
      let clientKey = "E5348970DF15F62AC955DEAF5F9EE343";
      let nonce = this.randomWord(false, 16);
      let requestBody = '{"code":"'+msg+'"}';
      let strToSign = requestUrl + ";" + nonce + ";" + timestamp + ";" + clientName + ";" + requestBody + ";";
      console.log("strToSign "+strToSign);
      let sha256Str = CryptoJS.SHA256(strToSign);
      console.log("sha256Str "+sha256Str);
      let hmacStr = CryptoJS.HmacSHA256(sha256Str, CryptoJS.enc.Hex.parse(clientKey)).toString();
      console.log("hmacStr "+hmacStr);
      let that = this;
      axios
        .post(
          requestUrl,
          {
            code: msg,
          },
          {
            headers: {
              "Content-Type": "application/json",
              clientName: clientName,
              timestamp: timestamp,
              auth: hmacStr,
              nonce: nonce
            },
          }
        )
        .then(function (response) {
          console.log("response.data "+response.data.errcode)
          if (response.data.errcode === 0) {
            console.log("成功")
            let random = response.data.obj.random;
            let authType = response.data.obj.authType;
            console.log("random "+ random +" authType "+authType)
            let resp = { random: random, authType: authType };
            if (that.isIos) {
              window.webkit.messageHandlers.callResponse.postMessage(resp);
            } else {
              window.jsBridge.callResponse(JSON.stringify(resp));
            }

            setTimeout(() => {
              that.showHint = true;
              that.hint_message = that.$t("home.hint_overtime");
              that.loading = false;
            }, 4000);
          } 
          else
            that.showError = true;
            that.error_message = that.$t("home.error_official");
            that.loading = false;
            if (that.isIos) {
              window.webkit.messageHandlers.callResponse.postMessage({
                resp: 1,
              })
            }
          }
        )
        .catch(function (error) {
          that.showHint = true;
          that.hint_message = that.$t("home.hint_service");
          that.loading = false;
          if(that.isIos) {
              window.webkit.messageHandlers.callResponse.postMessage({
                resp: 1,
              })
          }
        });
    },
    doSingle(actAuthToken, puf, code) {
      // 标签认证
      let requestUrl = "/zpws/api/hs02/auth";
      // 标签认证初始化
      let clientName = "client_jgwcjm";
      let timestamp = (Math.round(new Date().getTime()/1000)).toString();
      let clientKey = "E5348970DF15F62AC955DEAF5F9EE343";
      let nonce = this.randomWord(false, 16);
      let requestBody = '{"code":"'+code+'","puf":"'+puf+'","actAuthToken":"'+actAuthToken+'"}';
      let strToSign = requestUrl + ";" + nonce + ";" + timestamp + ";" + clientName + ";" + requestBody + ";";
      console.log("strToSign "+strToSign);
      let sha256Str = CryptoJS.SHA256(strToSign);
      console.log("sha256Str "+sha256Str);
      let hmacStr = CryptoJS.HmacSHA256(sha256Str, CryptoJS.enc.Hex.parse(clientKey)).toString();
      console.log("hmacStr "+hmacStr);
      let that = this;
      axios
        .post(
          requestUrl,
          {
            code: code,
            puf: puf,
            actAuthToken: actAuthToken,
          },
          {
            headers: {
              "Content-Type": "application/json",
              clientName: clientName,
              timestamp: timestamp,
              auth: hmacStr,
              nonce: nonce
            },
          }
        )
        .then(function (response) {
          console.log("response.data "+response.data.errcode)
          if (response.data.errcode === 0) {
            if(that.isIos) {
              window.webkit.messageHandlers.check.postMessage(
                response.data.obj
              )
            } else {
              window.jsBridge.check(JSON.stringify(response.data.obj));
            }

            setTimeout(() => {
              that.showHint = true;
              that.hint_message = that.$t("home.hint_overtime");
              that.loading = false;
            }, 4000);
          }
          else{
            that.showError = true;
            that.error_message = that.$t("home.error_official");
            that.loading = false;
            if (that.isIos) {
              window.webkit.messageHandlers.callResponse.postMessage({
                resp: 1,
              })
            }
          }
        })
        .catch(function (error) {
          that.showHint = true;
          that.hint_message = that.$t("home.hint_service");
          that.loading = false;
          if(that.isIos) {
              window.webkit.messageHandlers.callResponse.postMessage({
                resp: 1,
              })
          }
        });
    },
    checkCardStatus(response) {
      // 解绑
      if (window.initNfc != null) {
        window.initNfc = null;
      }
      if (window.doSingle != null) {
        window.doSingle = null;
      }
      let queryObj = response;
      
      let checkFlag = queryObj.checkFlag;
      let clientParam = queryObj.productCode;
      if(clientParam == null){
        clientParam = "004RR";
      }
      let strCheckFlag = "N";
      //checkFlag 1 启用开瓶检测 2 禁用开瓶检测
      if(checkFlag === "1"){
        strCheckFlag = "Y";
      }
      let check = queryObj.check;
      let checkOpenResult = "1";
      //check 105 已开封 106 未开封
      if(check === 105){
        checkOpenResult = "0";
      }
      this.$router.push({
        path: "../wushuang?showBar=1&checkParam="+strCheckFlag+checkOpenResult+"&clientParam="+clientParam
      });
      this.loading = false;
    },
    handleOpen() {},
    handleClose() {},
    gotoAbout() {
      this.$router.push({
        path: "../about",
      });
    },
    gotoProduct() {
      this.$router.push({
        path: "../product",
      });
    },
    switchVersion() {
      //切换版本
    },
    gotoFeedback() {
      this.$router.push({
        path: "../feedback",
      });
    },
    gotoUpdate() {
      this.$router.push({
        path: "../update",
      });
    },
    getResultCode(code) {
      alert(code);
    },
    randomWord(randomFlag, min, max) {
      var pos = "";
      var str = "",
        range = min,
        arr = [
          "0",
          "1",
          "2",
          "3",
          "4",
          "5",
          "6",
          "7",
          "8",
          "9",
          "a",
          "b",
          "c",
          "d",
          "e",
          "f",
          "g",
          "h",
          "i",
          "j",
          "k",
          "l",
          "m",
          "n",
          "o",
          "p",
          "q",
          "r",
          "s",
          "t",
          "u",
          "v",
          "w",
          "x",
          "y",
          "z",
          "A",
          "B",
          "C",
          "D",
          "E",
          "F",
          "G",
          "H",
          "I",
          "J",
          "K",
          "L",
          "M",
          "N",
          "O",
          "P",
          "Q",
          "R",
          "S",
          "T",
          "U",
          "V",
          "W",
          "X",
          "Y",
          "Z",
        ];

      // 随机产生
      if (randomFlag) {
        range = Math.round(Math.random() * (max - min)) + min;
      }
      for (var i = 0; i < range; i++) {
        pos = Math.round(Math.random() * (arr.length - 1));
        str += arr[pos];
      }
      return str;
    },
    encrypt(data) {
      var a;
      var md5 = crypto.createHash("md5");
      md5.update(data);
      var a = md5.digest("hex");
      return a;
    },
  },
};
</script>

<style lang="less" scoped>
.homeStart {
  position: relative;
  width: 100vw;
  height: 100vh;
  margin: 0;
  padding: 0;
  overflow: hidden;
  background: #fbfbfb;
  .bg {
    position: absolute;
    width: 93%;
    left: 3%;
    top: 15%;
  }
  .logoContainer {
    position: absolute;
    top: 8%;
    width: 100%;
    display: flex;
    justify-content: center;
  }
  .logo {
    width: 100px;
    height: 30px;
  }
  .text1 {
    position: absolute;
    top: 70%;
    left: 0;
    right: 0;
    text-align: center;
    font-size: 25px;
    font-family: PingFang;
    font-weight: 400;
    color: rgba(81, 74, 67, 1);
    line-height: 50px;
  }
  .text2 {
    position: absolute;
    top: 76%;
    left: 0;
    right: 0;
    text-align: center;
    font-size: 30px;
    font-family: PingFang;
    font-weight: 500;
    color: rgba(203, 146, 41, 1);
    line-height: 56px;
  }
  .playAndPlay {
    position: absolute;
    top: 84%;
    width: 95%;
    height: 45px;
    background: url(/static/buttonback.png) no-repeat;
    background-size: 100% 100%;
    border-style: none;
    transform: translate(2.5%, 0%);
    font-family: PingFang;
  }
  .left-menu {
    position: absolute;
    // background-image: url(/static/left_menu_button.png)  no-repeat;
    // width: 1rem;
    // height: 1rem;
    font-size: x-large;
    font-weight: 100;
    top: 2%;
    left: 3%;
  }
  .right-close {
    position: absolute;
    font-size: xx-large;
    font-weight: 200;
    top: 2%;
    right: 3%;
    z-index: 2300;
  }
  .my_menu {
    width: 1.2rem;
    height: 1.2rem;
    margin-right: 5px;
    text-align: center;
    font-size: 18px;
    vertical-align: middle;
  }
  .mask_one {
    width: 100%;
    height: 100%;
    .mask {
      width: 100%;
      height: 100%;
      position: fixed;
      top: 0;
      left: 0;
      background: #000;
      opacity: 0.3;
    }
    .error_center {
      position: absolute;
      width: 85%;
      height: 50%;
      left: 7.5%;
      top: 20%;
      z-index: 50;
    }
    .error_img {
      position: absolute;
      width: 100%;
      height: 15rem;
    }
    .error_text {
      position: absolute;
      width: 100%;
      height: 30%;
      background-color: #ffffff;
      top: 10rem;
    }
    .error_text_center_content {
      margin-top: 4%;
      font-size: 17px;
      font-family: PingFang;
      font-weight: 500;
      color: rgba(51, 51, 51, 1);
      text-align: center;
      z-index: 100;
      background-color: #ffffff;
    }
  }
  .mask_two {
    width: 100%;
    height: 100%;
    .mask {
      width: 100%;
      height: 100%;
      position: fixed;
      top: 0;
      left: 0;
      background: #000;
      opacity: 0.3;
    }
    .hint_center {
      position: absolute;
      width: 85%;
      height: 50%;
      left: 7.5%;
      top: 20%;
      z-index: 50;
    }
    .hint_img {
      position: absolute;
      width: 100%;
      height: 10rem;
    }
    .hint_text {
      position: absolute;
      width: 100%;
      height: 50%;
      background-color: #ffffff;
      top: 9.5rem;
    }
    .hint_text_center_title {
      margin-top: 9%;
      font-size: 23px;
      font-family: PingFang;
      font-weight: 500;
      color: rgba(51, 51, 51, 1);
      text-align: center;
      z-index: 100;
      background-color: #ffffff;
    }
    .hint_text_center_content {
      margin-top: 4%;
      font-size: 17px;
      font-family: PingFang;
      font-weight: 500;
      color: rgba(51, 51, 51, 1);
      text-align: center;
      z-index: 100;
      background-color: #ffffff;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/home/home.vue